import { User } from '../store/user/types'

export const UnauthorizedResponse = 'Unauthorized'

export type Token = string

export interface ErrorResponse<T = string> {
  message: string
  status: T
}

export interface RefreshTokenSuccessResponse {
  benutzer: User
  token: Token
  refreshToken: Token
}

export interface LoginSuccessResponse {
  benutzer: User
  token: Token
  refreshToken: Token
}

export interface RegisterSuccessResponse {
  benutzer: User
  token: Token
  refreshToken: Token
}

export interface ForgotPasswordSuccessResponse {
  status: 'Success'
  message: string
}

export interface ResetPasswordSuccessResponse {
  benutzer: User
  token: Token
}
